import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useRef } from "react";
import classnames from "classnames";
import { decodeHtmlContent } from "../../../../utils";
import { hexToRgb } from "utils/html";

export const inputClassName = props => {
  const { className, multiLine, underline, boxed, error } = props;

  const prefixCls = "textfield";

  /*eslint-disable no-nested-ternary */
  const variant = boxed ? "boxed" : underline ? "underline" : null;
  /*eslint-enable no-nested-ternary */

  const componentCls = classnames(
    prefixCls,
    {
      [`${prefixCls}--multi`]: multiLine,
      [`${prefixCls}--${variant}`]: variant,
      [`${prefixCls}--error`]: error,
    },
    className
  );

  return componentCls;
};

const Textfield = props => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const textInput = useRef(null);

  const togglePasswordVisibility = () => {
    setPasswordVisible(prevPasswordVisible => !prevPasswordVisible);
  };

  useEffect(() => {
    if (
      (!!props.value &&
        props.dataType &&
        (props.dataType === "String" || props.dataType === "TextArea")) ||
      (props.type && (props.type === "String" || props.type === "TextArea"))
    ) {
      textInput.current.focus();
    }
  }, [props.value, props.dataType, props.type]);

  const { value, multiLine, helpText, type, ...rest } = props;
  const Component = multiLine ? "textarea" : "input";
  const componentCls = inputClassName(props);

  delete rest.flat;
  delete rest.meta;
  delete rest.boxed;
  delete rest.error;
  delete rest.visible;
  delete rest.intl; //avoid complaints about invalid props on native elements

  const decodedValue = decodeHtmlContent(value);

  const inputType = type === "password" && passwordVisible ? "text" : type;

  return (
    <Fragment>
      <div style={{ position: "relative" }}>
        <Component
          {...rest}
          value={decodedValue}
          type={inputType}
          ref={textInput}
          className={componentCls}
          style={{ backgroundColor: (props.color && hexToRgb(props.color, 25)) || "" }}
        />
        {type === "password" && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            <i className={`fas fa-eye${passwordVisible ? "-slash" : ""}`}></i>
          </button>
        )}
      </div>
      {helpText && helpText != "#void help text#" && <div className="help-text">{helpText}</div>}
    </Fragment>
  );
};

Textfield.propTypes = {
  className: PropTypes.string,
  multiLine: PropTypes.bool,
  underline: PropTypes.bool,
  boxed: PropTypes.bool,
  error: PropTypes.any,
  value: PropTypes.string,
  dataType: PropTypes.string,
  type: PropTypes.string,
  helpText: PropTypes.string,
  color: PropTypes.string,
};

export default Textfield;



// WEBPACK FOOTER //
// ./casper/sass/components/textfield/textfield.js